import $ from 'jquery';

const bodyHtml = $('body,html');
const body = $('body');

/* ======================================
body fix
====================================== */
let scrollPosi;
let scrolling = false

function bodyFix() {
	scrollPosi = $(window).scrollTop();

	body.addClass('is-fixed');
	body.css({ top: -scrollPosi });
}

function bodyFixReset() {
	body.removeClass('is-fixed');
	body.removeAttr('style');
	bodyHtml.scrollTop(scrollPosi);
}

$(function () {
	const btnMenu = $('.js-header-btn');
	const btnClose = $('.js-header-close');
	const header = $('.js-header');
	const content = $('.js-header-content');
	const link = $('.js-header-link');
	let contime

	if (btnMenu.length) {
		function handleFixedHeader() {
			const hMv = $('.c-mv1').innerHeight()

			if ($(window).scrollTop() >= hMv) {
				header.addClass('is-fixed')

			} else {
				header.removeClass('is-fixed')
			}
		}

		handleFixedHeader()

		$(window).on('resize scroll', () => handleFixedHeader())

		$(window).on('load scroll resize', function () {
			if ($(window).scrollTop() > 150) {
				header.addClass('is-scrolling')

			} else {
				if (!scrolling || !$('.js-modal.is-active').length) {
					header.removeClass('is-scrolling')
				}

				if (scrolling) {
					header.addClass('is-scrolling')
					scrolling = false
				}
			}
		})

		link.on('click', function (e) {
			e.preventDefault()
		})

		btnMenu.on('click', function () {
			header.addClass('is-active');

			if ($(window).outerWidth() < 961) {
				if (header.hasClass('is-scrolling')) {
					scrolling = true

				} else {
					scrolling = false
				}

				bodyFix();
			}
		});

		$(window).on('resize', function () {
			if ($(window).outerWidth() > 960) {
				if (!$('.js-modal.is-active').length) {
					bodyFixReset();
				}

				if (!$('.js-modal.is-active').length || !scrolling) {

					header.removeClass('is-scrolling')
				}
			}
		});

		if ($('.js-scrolltop').length) {
			$('.js-scrolltop').on('click', () => $('html, body').animate({ scrollTop: 0 }, 1000))
		}

		$(window).on('load resize', function () {
			const hWindow = $(window).innerHeight();

			content.css('height', hWindow);

			if ($(window).outerWidth() > 960) {
				if (contime) {
					clearTimeout(contime)
				}

				content.removeAttr('style');

			} else {
				contime = setTimeout(() => {
					content.css({
						'transition': '.3s ease',
					})
				}, 500);
			}
		});

		btnClose.on('click', function () {
			header.removeClass('is-active');

			if (!$('.js-modal.is-active').length) {
				bodyFixReset();
			}
		})

		if ($('.js-haccor').length) {
			$('.js-haccor').each(function () {
				$(this).on('click', function () {
					$(this).next().slideToggle()
					$(this).toggleClass('is-active')
				})
			})
		}

		header.on('menu-close', function () {
			header.removeClass('is-active')
			bodyFixReset()
		});
	}
});
